module.exports = dormakaba.vendorTerrific['@dormakaba/ajax'];